import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/dock_to_right.svg?url")